import {Carousel} from "../UI/carousel.es6";
import {HeroCard} from "../UI/hero-card.es6";

window.location.pathname === "/" && (function() {
	new Carousel(document.querySelector("section.testimonials ul"), true);
	new HeroCard(document.querySelector("section.hero .image-container"));
})();
